export enum ActivityEntity {
  INSTRUCTIONAL = "INSTRUCTIONAL",
  ASSIGNMENT = "ASSIGNMENT",
  TUTORING = "TUTORING",
}
